import angular from 'angular';
import StripPrefixDirective from './strip-prefix.directive';

let StripPrefixModule = angular.module('strip-prefix-module', [])

    .directive('stripPrefix', StripPrefixDirective)

    .name;

export default StripPrefixModule;


// WEBPACK FOOTER //
// ./client/app/common/strip-prefix/index.js